<template>
  <Layout>
    <div class="row app-user-avatar">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="card-body-form">
              <div class="row">
                <div class="col-md-12">
                  <div class="mb-3" style="text-align: center;">
                    <image-upload ratio="1:1" ref="image"></image-upload>
                  </div>
                  <div class="mb-3" style="text-align: center;">
                    <p style="font-size: 15px;">上传用户头像</p>
                    <!-- <p style="color: #C0C4CC; font-size: 13px; margin: 0">
                      建议上传正方形的图片
                    </p> -->
                  </div>
                </div>
              </div>
            </div>

            <div class="row submit-bar">
              <div class="col-md-12">
                <div class="bar-handle">
                  <button
                    @click="submitPreserve()"
                    class="btn-sm btn btn-primary"
                    type="button"
                    v-if="power['编辑']"
                  >
                    提交
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Vue from "vue";
import Swal from "sweetalert2";
import Layout from "../../layouts/main";
import user from "../../../server/api/user";
import auth from "../../../server/api/auth";
import imageUpload from "../../../components/imageUpload";

export default {
  components: {
    Layout,
    imageUpload,
  },
  data() {
    return {
      item: {},
      index_id: true,
      params: {
        userType: 1,
        noShowLoading: false,
      },
      power: "",
    };
  },

  mounted() {
    this.power = this.utils.currentPower("创作平台-用户中心");
    // // 获取详情
    this.getUserInfo();
    // if (this.$route.query.id) {
    //   this.index_id = this.$route.query.id;
    //   this.fetch()
    // }
  },

  methods: {
    getUserInfo() {
      auth.userInfo(this.params).then((resp) => {
        console.log('用户信息',resp)
        if (resp.data) {
          this.$refs.image.setImageUrl(resp.data.avatar);
          this.cookies.setCookie("user", JSON.stringify(resp.data));
        }
      });
    },

    submitPreserve() {
      let params = {};
      params.userAvatar = this.$refs.image.getImageUrl();
      if (!params.userAvatar) {
        Vue.swal("请上传头像");
        return;
      }
      user.avatarModify(params).then((resp) => {
        if (resp.code == 0) {
          Vue.swal({
            icon: "success",
            title: "保存成功！",
            showConfirmButton: false,
            timer: 1000,
          });
          this.getUserInfo();
          location.reload();
        } else {
          Vue.swal(resp.msg);
        }
      });
    },

    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.app-user-avatar .submit-bar {
  text-align: center;
}

.app-user-avatar .submit-bar .bar-handle {
  display: inline-block;
  float: inherit;
}

.app-user-avatar .submit-bar .bar-handle button {
  margin-left: 0;
}

.app-user-avatar .app-image-upload {
  display: inline-block;
}

.app-user-avatar .app-image-upload .avatar-uploader .el-upload {
  border-radius: 50%;
}
</style>
